import ReviewCard from "../review-card";
import * as Constants from "../../config";
import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";

export default function Reviews(props){
    const { t } = useTranslation();
    const [data,setData] = useState();

    function getData() {
        fetch(Constants.apiurl + Constants.reviews)
        .then((response) => response.json())
        .then((data) => {
            setData(isMobile? data.slice(0,3) : data);
        })
        .catch((err) => {
           console.log(err.message);
        });
    }

    useEffect(() => {
        getData();
     }, []);

    return(
        <>
            <div id="reviews">
                <div id="title">{t('Avis')}</div>
                <div id='cards-block'>
                    <div id='cards-panel'>
                        {!!(data) ? data.map(x=>
                        <ReviewCard data={x} /> 
                        ) : ""}     
                    </div> 
                </div>       
                <br/>
                <div 
                onClick={()=> window.open("https://www.google.com/maps/place/LM+PLATINUM+ESTATES+-+Agence+Immobili%C3%A8re/@3.8558268,11.5474463,17z/data=!4m8!3m7!1s0x108bcf898fdaf17d:0xec6f095554f52379!8m2!3d3.8558268!4d11.5474463!9m1!1b1!16s%2Fg%2F11krywvqcj?entry=ttu&g_ep=EgoyMDI1MDMxOS4yIKXMDSoASAFQAw%3D%3D", "_blank")}
                className="white-button">{t('Voir autre')}</div>
            </div>
        </>
    )
}
